export default __webpack_public_path__ + "static/media/indexx500.ffde6cbf.png";